import React from "react";
import {
  IconAnalytics,
  IconAnalyticsBlue,
  IconApps,
  IconAppsBlue,
  IconConstruction,
  IconConstructionBlue,
  IconContentPasteSearch,
  IconContentPasteSearchBlue,
  IconCrown,
  IconCrownBlue,
  IconFolderManaged,
  IconFolderManagedBlue,
  IconLocalPostOffice,
  IconLocalPostOfficeBlue,
  IconNestCamWallMount,
  IconNestCamWallMountBlue,
  IconQuestManagement,
  IconQuestManagementBlue,
} from "assets/svg";
import { MenuStatusEnum } from "common/enums/MenuStatus.enum";

export const menuAdmin = [
  {
    to: "/admin/dashboard",
    icon: <IconApps />,
    iconActive: <IconAppsBlue />,
    label: "ダッシュボード",
    status: MenuStatusEnum.ENABLED,
  },
  {
    to: "/admin/quest-management",
    icon: <IconQuestManagement />,
    iconActive: <IconQuestManagementBlue />,
    label: "クエスト管理",
    status: MenuStatusEnum.ENABLED,
  },
  {
    to: "/admin/review-company",
    icon: <IconContentPasteSearch />,
    iconActive: <IconContentPasteSearchBlue />,
    label: "ユーザー審査",
    status: MenuStatusEnum.ENABLED,
  },
  {
    to: "/admin/company-management",
    icon: <IconFolderManaged />,
    iconActive: <IconFolderManagedBlue />,
    label: "ユーザー管理",
    status: MenuStatusEnum.ENABLED,
  },
  {
    to: "/admin/transaction-monitoring",
    icon: <IconNestCamWallMount />,
    iconActive: <IconNestCamWallMountBlue />,
    label: "取引監視",
    status: MenuStatusEnum.DISABLED,
  },
  {
    to: "/admin/report-analysis",
    icon: <IconAnalytics />,
    iconActive: <IconAnalyticsBlue />,
    label: "レポート・分析",
    status: MenuStatusEnum.DISABLED,
  },
  {
    to: "/admin/system-maintenance",
    icon: <IconConstruction />,
    iconActive: <IconConstructionBlue />,
    label: "システムメンテナンス",
    status: MenuStatusEnum.DISABLED,
  },
  {
    to: "/admin/global-ranking",
    icon: <IconCrown />,
    iconActive: <IconCrownBlue />,
    label: "全体ランキング",
    status: MenuStatusEnum.ENABLED,
  },
  {
    to: "/admin/conversation-inquiry",
    icon: <IconLocalPostOffice />,
    iconActive: <IconLocalPostOfficeBlue />,
    label: "お問い合わせ管理",
    status: MenuStatusEnum.ENABLED,
  },
];
